import type { AchievementId, Medal } from '@tg/shared';
import { badgeSvg, momentIconMarkup, BADGE_SIZE } from '@/art/badges';
import { svgDoc, type ArtTheme } from '@/art/covers/kit';

const uri = (svg: string) => `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
const cache = new Map<string, string>();

function memo(key: string, make: () => string): string {
  let v = cache.get(key);
  if (v === undefined) cache.set(key, (v = uri(make())));
  return v;
}

/** Data-URI of an achievement badge (null medal = not earned, muted). */
export function badgeUri(id: AchievementId, medal: Medal | null, theme: ArtTheme): string {
  return memo(`b:${id}:${medal ?? '-'}:${theme}`, () => badgeSvg(id, medal, theme));
}

/** Data-URI of a moment icon ('win' — big win, 'place' — tournament place). */
export function momentUri(kind: 'win' | 'place', theme: ArtTheme): string {
  return memo(`m:${kind}:${theme}`, () => svgDoc(BADGE_SIZE, BADGE_SIZE, momentIconMarkup(kind, theme)));
}
